var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import Button from '../../Button';
import Card, { ElevationLevel } from '../../Card';
import getIcon from '../../utils/getIcon';
import Skeleton, { withSkeleton } from '../../Skeleton';
import { ComponentThemeProvider } from '../../ThemeProvider';
import { ErrorMessage } from '../Input';
import Label from '../Label';
import formTheme from '../theme';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n"], ["\n  position: relative;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.base.color.normal;
});
var BaseArrowIcon = getIcon('ArrowMiniDown');
var ArrowIcon = function (_a) {
    var className = _a.className;
    return React.createElement(BaseArrowIcon, { className: className });
};
var Arrow = styled(ArrowIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transition: transform 250ms ease-in-out;\n  will-change: transform;\n  margin-left: 1rem;\n  ", "\n"], ["\n  transition: transform 250ms ease-in-out;\n  will-change: transform;\n  margin-left: 1rem;\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && 'transform: scaleY(-1);';
});
var fadeIn = keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  0% { opacity: 0; transform: translateY(-1rem) }\n"], ["\n  0% { opacity: 0; transform: translateY(-1rem) }\n"])));
var Dropdown = styled(Card)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  z-index: 1;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  animation: ", " 250ms 0s ease-in-out both;\n  padding: ", ";\n\n  max-height: 300px;\n  overflow: auto;\n"], ["\n  z-index: 1;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  animation: ", " 250ms 0s ease-in-out both;\n  padding: ", ";\n\n  max-height: 300px;\n  overflow: auto;\n"])), fadeIn, function (_a) {
    var component = _a.theme.component;
    return component.form.select.option.margin;
});
var defaultColor = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: transparent;\n  box-shadow: inset 0 0 0 1px ", ";\n  &:hover,\n  &:focus,\n  &:active {\n    border: none;\n    background: none;\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"], ["\n  background: transparent;\n  box-shadow: inset 0 0 0 1px ", ";\n  &:hover,\n  &:focus,\n  &:active {\n    border: none;\n    background: none;\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.borderColor.normal;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.borderColor.checked;
});
var disabledColor = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  &,\n  &:disabled,\n  &.disabled {\n    background: ", ";\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"], ["\n  &,\n  &:disabled,\n  &.disabled {\n    background: ", ";\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.backgroundColor.disabled;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.borderColor.disabled;
});
var errorColor = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  box-shadow: inset 0 0 0 2px ", ";\n  color: ", ";\n"], ["\n  box-shadow: inset 0 0 0 2px ", ";\n  color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.borderColor.error;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.textColor.error;
});
var SelectItem = styled(Button)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  border: none;\n  height: auto;\n  justify-content: space-between;\n  transition: box-shadow 250ms ease-in-out;\n  will-change: box-shadow;\n  font-size: ", ";\n  padding: ", ";\n  ", "\n  ", ";\n  ", ";\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  border: none;\n  height: auto;\n  justify-content: space-between;\n  transition: box-shadow 250ms ease-in-out;\n  will-change: box-shadow;\n  font-size: ", ";\n  padding: ", ";\n  ", "\n  ", ";\n  ", ";\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.fontSize.small;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.select.default.padding;
}, defaultColor, function (_a) {
    var disabled = _a.disabled;
    return disabled && disabledColor;
}, function (_a) {
    var error = _a.error;
    return error && errorColor;
});
var Option = styled(Button)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  justify-content: flex-start;\n  font-size: ", ";\n  padding: ", ";\n  margin: ", ";\n  text-align: left;\n  height: auto;\n"], ["\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  justify-content: flex-start;\n  font-size: ", ";\n  padding: ", ";\n  margin: ", ";\n  text-align: left;\n  height: auto;\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.fontSize.small;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.select.option.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.select.option.margin;
});
export var Select = function (_a) {
    var options = _a.options, onChange = _a.onChange, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, error = _a.error, placeholder = _a.placeholder, label = _a.label, className = _a.className;
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var selected = __spreadArrays(options.filter(function (opt) { return opt.value === value; }), options)[0];
    var displayName = value || !placeholder ? selected.displayName : placeholder;
    return (React.createElement(ComponentThemeProvider, { theme: formTheme },
        label && React.createElement(Label, { "data-testid": "select-label" }, label),
        React.createElement(Wrapper, { "data-testid": "select-wrapper", className: className, onBlur: function (_a) {
                var currentTarget = _a.currentTarget, relatedTarget = _a.relatedTarget;
                return !currentTarget.contains((relatedTarget || document.activeElement)) &&
                    setIsOpen(false);
            }, tabIndex: -1 },
            React.createElement(SelectItem, { type: "button", onClick: function () { return setIsOpen(!isOpen); }, fullWidth: true, disabled: disabled, error: error, "data-testid": "select-item" },
                displayName,
                " ",
                React.createElement(Arrow, { isOpen: isOpen })),
            isOpen && (React.createElement(Dropdown, { elevationLevel: ElevationLevel['4dp'] }, options.map(function (opt) { return (React.createElement(Option, { key: opt.value, fullWidth: true, size: "small", type: "button", "data-testid": "select-option", onClick: function () {
                    onChange(opt.value);
                    setIsOpen(false);
                } }, opt.displayName)); })))),
        !!error && React.createElement(ErrorMessage, { error: error })));
};
export var SelectSkeleton = function () { return (React.createElement(ComponentThemeProvider, { theme: formTheme },
    React.createElement(Skeleton, { height: "2.25rem" }))); };
export default withSkeleton(Select, SelectSkeleton);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=index.js.map